export default {"src":"/_next/static/media/check-circle-fill.ac037607.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};